'use strict';

var address = require('./pages/checkout/address'),
	loqate = require('./loqate'),
	formPrepare = require('./pages/checkout/formPrepare'),
	linchpin = require('int_googletagmanager/linchpin/emailsignup'),
	optinout = require('./optinout'),
	reCaptcha = require('int_recaptcha/recaptcha');

var isFormSubmitted = false;

function initializeEvent () {

	var linchpinAnalitics = function(e) {
		// GTM Linchpin analytics
		try {
			if (SitePreferences.GTM_ENABLED) {
				linchpin.guestCheckoutEmailSignup(e);
			}
		} catch (error) {
			window.console.warn(error);
		}
	};

	var submitHandler = function (event) {
		// Prevents multiple registration form submission
		var $form = $('#RegistrationForm');

		if (!$form.valid() || !birthdayIsValid()) {
			reCaptcha.resetRecaptchaForms();
			return false;
		}

		if (!isFormSubmitted) {
			isFormSubmitted = true;
			linchpinAnalitics(event);
		} else {
			event.preventDefault();
			return false;
		}
	};

	if ($('#RegistrationForm').length > 0) {
		$('#RegistrationForm').on('submit', submitHandler);
		reCaptcha.initRecaptchaOnForm('#RegistrationForm', function() {
			$('#RegistrationForm').trigger('submit');
		});
		updatePasswordRulesState();
	}
}

function updatePasswordRulesState() {
	var $passwordEl = $('#RegistrationForm').find("[id$='password']");

	if ($passwordEl.length && $('.validation-rule').length) {
		$passwordEl.on('input keyup', function() {
			var password = $passwordEl.val();
			var $lengthRule = $('.validation-rule[data-rule="length"]');
			var $numberRule = $('.validation-rule[data-rule="number"]');
			if ($lengthRule.length) {
				var hasLength = password.length >= 8;
				$lengthRule.toggleClass('valid', hasLength).toggleClass('invalid', !hasLength);
			}
			if ($numberRule.length) {
				var hasNumber = /\d/.test(password);
				$numberRule.toggleClass('valid', hasNumber).toggleClass('invalid', !hasNumber);
			}
		});
	}
}

// process chosen birthday, if the user is younger that 18, show restriction note
function birthdayIsValid() {
	var $vipmeSignupForm = $('form.vipme-signup');
	var $birthday = $vipmeSignupForm.find("[id$='birthday']");
	if ($birthday.length && $birthday.val()) {
		var dateValue = $birthday.val().split('/');
		var dayValue = dateValue[0];
		var monthValue = dateValue[1] - 1;
		var yearValue = dateValue[2];
		var currentDate = new Date();
		var adultAgeDate = new Date(yearValue, monthValue, dayValue);
		adultAgeDate.setFullYear(adultAgeDate.getFullYear() + 18);

		if (currentDate < adultAgeDate) {
			$('.age-restriction-note').addClass('active');
			$birthday.addClass('error');

			reCaptcha.resetRecaptchaForms();
			return false;
		}
		$('.age-restriction-note').removeClass('active');
		$birthday.removeClass('error');
		return true;
	}
	return true;
}

exports.init = function () {
	initializeEvent();

	var $registrationForm = $('#RegistrationForm');
	if ($registrationForm.find('[id$="_addressFind"]').length) {
		loqate.init($registrationForm);
	}

	optinout.init();

	var continueSelector = '[name$="profile_confirm"]';
	if ($registrationForm.hasClass('checkout-guest-registration')) {
		continueSelector = '[name$="editAddress_save"]';
	}

	formPrepare.init({
		continueSelector: continueSelector,
		formSelector: '#RegistrationForm',
		replaceInvalidInput: true,
		autofillValidate: true,
		keyup: false
	});

	if ($registrationForm.find('[name$="country"]').length) {
		address.dynamicAddressFieldsHandler($registrationForm);
	}
};
